import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalForm from "../components/ModalForm";
import { changeField, reviewing } from "../modules/modal";

const ModalContainer = () => {
  const dispatch = useDispatch();
  const { score, review, popupState } = useSelector(({ modal }) => ({
    score: modal.score,
    review: modal.review,
    popupState: modal.popupState,
  }));
  const [clickLock, setClickLock] = useState(false);

  const onChangeScore = (seq) => {
    dispatch(changeField({ key: "score", value: seq }));
  };
  const onChangeReview = (e) => {
    dispatch(changeField({ key: "review", value: e.target.value }));
  };
  const onClose = () => {
    if (!clickLock) {
      setClickLock(true);
      dispatch(changeField({ key: "popupState", value: false }));
      setClickLock(false);
    }
  };
  const onSubmit = () => {
    if (!clickLock) {
      if (review.length >= 10) {
        setClickLock(true);
        dispatch(changeField({ key: "popupState", value: false }));
        dispatch(reviewing({ score, review }));
        setClickLock(false);
        if (window.Andorid) {
          window.Android.exit();
        } else {
          window.open("https://home-learn.co.kr/", "_self").close();
        }
      } else {
        alert("개선 의견 내용을 10자 이상 입력해주세요!");
      }
    }
  };
  return popupState === true ? (
    <ModalForm
      score={score}
      onChangeScore={onChangeScore}
      review={review}
      onChangeReview={onChangeReview}
      onClose={onClose}
      onSubmit={onSubmit}
    ></ModalForm>
  ) : (
    <></>
  );
};

export default ModalContainer;
